import { render } from "./AppSettings.vue?vue&type=template&id=4359d484&scoped=true"
import script from "./AppSettings.vue?vue&type=script&lang=js"
export * from "./AppSettings.vue?vue&type=script&lang=js"

import "./AppSettings.vue?vue&type=style&index=0&id=4359d484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4359d484"]])

export default __exports__